import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { CrudProvider } from '../../providers/crud/crud';
import { UtiltiyProvider } from '../../providers/utiltiy/utiltiy';
import { CabsandTakeTemplatePage } from '../cabsand-take-template/cabsand-take-template';
import { KlmrTakeTemplatePage } from '../klmr-take-template/klmr-take-template';
@IonicPage()
@Component({
  selector: 'page-cabsand-take-template-add',
  templateUrl: 'cabsand-take-template-add.html',
})
export class CabsandTakeTemplateAddPage {
  isUpdate: boolean = false;
  actionAllowed: boolean = true;
  disabled: boolean = true;
  params: any = {};
  questions_alphabet:any = [];
  questions_numeric:any = [];
  category:any = [];

  methodName:any = null;
  constructor(public navCtrl: NavController, public navParams: NavParams, private api: CrudProvider, public utiltiy: UtiltiyProvider) {
    this.params = this.navParams.get('param');
    this.disabled = this.navParams.get('disabled');
    console.log(this.disabled)
    if (this.params) {
      this.isUpdate = true;

    }
  }

  ionViewDidLoad() {
    this.getMetaData();
  }

  async getMetaData(){
    this.utiltiy.startLoading();
    let templateList = await this.getData();
    this.generateData(templateList)

    this.utiltiy.stopLoading();
  }

  async generateData(templateList){
    let questions_alphabet_list = [];
    let questions_numeric_list = [];
    let category_list = [];

    templateList.questions_alphabet.forEach(element => {
      let obj = {
        "id":element.id,
        "value":null,
        "question":element.take_5_questions,
      }
      questions_alphabet_list.push(obj);
    });

    templateList.questions_numeric.forEach(element => {
      let obj = {
        "id":element.id,
        "value":null,
        "question":element.take_5_questions,
      }
      questions_numeric_list.push(obj);
    });

    let keys = Object.keys(templateList);


    keys.forEach(element => {
      if(element != "ppe_category" && element != "questions_alphabet" && element != "questions_numeric" ){
        let key = templateList[element];
        let options = [];
        key.forEach(element_ => {
          let optionObj = {
            "id":element_.take_5_ppe_itm,
            "value":false,
            "question":element_.take_5_ppe_itm,
          }
          options.push(optionObj);
        });
        let obj = {
          "id":element,
          "value":null,
          "question":element,
          "option":options,
        }
        category_list.push(obj);
      }
      
    });

    if(this.isUpdate){
      this.mergeData(questions_alphabet_list,questions_numeric_list,category_list);
    }else{
      this.category = category_list;
      this.questions_alphabet = questions_alphabet_list;
      this.questions_numeric = questions_numeric_list;
      console.log("===",this.category)
    }
  }

  async mergeData(questions_alphabet_list,questions_numeric_list,category_list){
    this.methodName = this.params.take_5_template_task;
    let take_5_template_ppe = this.params.take_5_template_ppe.split(",");
    let take_5_template_questions = JSON.parse(this.params.take_5_template_questions);

    let keys = Object.keys(take_5_template_questions);
    keys.forEach(element => {
      let i = questions_alphabet_list.findIndex(list_ => list_['id'] == element);
      if(i != -1){
        questions_alphabet_list[i].value = take_5_template_questions[element];
      }
     
      let j = questions_numeric_list.findIndex(list_ => list_['id'] == element);
      if(j != -1){
        questions_numeric_list[j].value = take_5_template_questions[element];
      }
      
    });

 

    category_list.forEach(element => {
      element.option.forEach(element_ => {
        let i = take_5_template_ppe.findIndex(list_ => list_ == element_['id']);
        if(i != -1){
          element_.value = true;
        }
      });
    });

    this.category = category_list;
    this.questions_alphabet = questions_alphabet_list;
    this.questions_numeric = questions_numeric_list;

  }

  async getData(){
    let formData: FormData = new FormData();

    formData.append("method_name", "take_5_questions_list");
    return this.api.post("/tansix_prestart/take_5/Add_Templates", false,formData)
      .then((result: any) => {
        console.log("result", result)
        if (result.status) {
          return result.result;
        }else{
         return [];
        }
      }, err => {
        this.utiltiy.stopLoading();
        this.utiltiy.toaster(err.error.message);
        return [];
      })

}

submit(){
  if(!this.methodName){
    this.utiltiy.toaster("Task Name Required");
    return
  }
  let formData: FormData = new FormData();

  let obj = {};
  this.questions_alphabet.forEach(element => {
    if(element.value){
      let key = element.id
      let value = element.value
      obj[key] = value;
    }
  });
  
  this.questions_numeric.forEach(element => {
    if(element.value){
      let key = element.id
      let value = element.value
      obj[key] = value;
    }
  });
  
  this.category.forEach(element => {
    element.option.forEach(element_ => {
      if(element_.value){
        formData.append("take_5_template_ppe[]",element_.question);
      }
    });
  });

  formData.append("take_5_template_task",this.methodName);
  formData.append("take_5_template_questions",JSON.stringify(obj));
  if(this.isUpdate){
    formData.append("id", this.params.id);
    formData.append("method_name", "update_template");

  }else{
    formData.append("method_name", "add_template");
  }
  
  console.log("obj",obj)
  console.log("formData",formData);
  this.utiltiy.startLoading();
  this.addTemplate(formData);
}

addTemplate(formData){
   this.api.post("/tansix_prestart/take_5/Add_Templates", false,formData)
  .then((result: any) => {
    console.log("result", result)
    this.utiltiy.stopLoading();
    if (result.status) {
      this.utiltiy.toaster(result.message);
      this.navCtrl.setRoot(CabsandTakeTemplatePage);
    }
  }, err => {
    this.utiltiy.stopLoading();
    this.utiltiy.toaster(err.error.message);
  })
}

}



// WEBPACK FOOTER //
// ./src/pages/cabsand-take-template-add/cabsand-take-template-add.ts